import { axiosInstance } from 'boot/axios';
import isEmpty from 'lodash/isEmpty';
import InsurancePermission from 'src/models/insurancePermission';

export function getInsuranceRight({ commit, state, rootState }, forced) {
  if (!rootState.user.permissions.mayReadInsuranceRight) return;
  if (state.insuranceRight !== null && !forced) return;
  commit('setIsLoadingInsuranceRight', true);
  axiosInstance
    .get('InsuranceRight')
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('setInsuranceRight', new InsurancePermission(response.data));
      }
    })
    .finally(() => commit('setIsLoadingInsuranceRight', false));
}

export function requestInsuranceRight({ commit }, payload) {
  commit('setIsSavingInsuranceRight', true);

  const hasDutchIncome = payload.dutchWork?.key === 'yes';
  const hasBenefit = payload.benefit?.key === 'yes';
  const hasOtherIncome = payload.incomeOtherCountry?.key === 'yes' || payload.incomeOtherCountryExtra?.key === 'yes';
  const isSelfEmployed = payload.selfEmployed?.key === 'yes';

  const formData = new FormData();
  if (payload.dutchWork) {
    formData.set('HasDutchIncome', hasDutchIncome);
  }
  if (payload.benefit) {
    formData.set('HasBenefit', hasBenefit);
  }
  if (payload.incomeOtherCountry || payload.incomeOtherCountryExtra) {
    formData.set('HasOtherIncome', hasOtherIncome);
  }
  if (payload.selfEmployed) {
    formData.set('IsSelfEmployed', isSelfEmployed);
  }
  !hasDutchIncome &&
    !hasBenefit &&
    !hasOtherIncome &&
    !isSelfEmployed &&
    formData.set('LastDutchIncome', payload.lastDutchIncome?.key);
  payload.documents.forEach((file) => formData.append('files', file.file));

  return axiosInstance.post('InsuranceRight', formData).finally(() => {
    commit('setIsSavingInsuranceRight', false);
  });
}
